import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  createMigrate,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import pgReducer from "./slices/pgSlice";
import countReducer from "./slices/countSlice";
import lawfirmReducer from "./slices/lawFirmSlice";
import teamMemberReducer from "./slices/teamMemberSlice";
import bondArchivesReducer from "./slices/bondArchivesSlice";
import pgBondsReducer from "./slices/pgBondsSlice";
import lawFirmBondsReducer from "./slices/lawFirmBondsSlice";
import premiumReducer from "./slices/premiumSlice";
import { rtkApi } from "../api/rtkApi";

const PERSIST_VERSION = 2;

const migrations = {
  2: (state) => {
    if (!state?.auth) return state;
    const { accessToken, refreshToken, ...authWithoutTokens } = state.auth;
    return { ...state, auth: authWithoutTokens };
  },
};

const persistConfig = {
  key: "root",
  version: PERSIST_VERSION,
  storage,
  blacklist: ["bondArchives", "pgBonds", "lawFirmBonds", "api"],
  migrate: createMigrate(migrations, { debug: false }),
};

const rootReducer = combineReducers({
  auth: authReducer,
  pg: pgReducer,
  counter: countReducer,
  lawfirm: lawfirmReducer,
  teamMember: teamMemberReducer,
  bondArchives: bondArchivesReducer,
  pgBonds: pgBondsReducer,
  lawFirmBonds: lawFirmBondsReducer,
  premium: premiumReducer,
  [rtkApi.reducerPath]: rtkApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(rtkApi.middleware),
});

const persistor = persistStore(store);

export { store, persistor };
